import React, { useContext, useEffect } from 'react';
import Logo from "../../../../assets/images/LogoNew.svg";
import { DialogContext } from '../../../../store/context/DialogContext';
import BusinessContent from '../BusinessLiteForms/BusinessContent';
import '../IndividualLite.scss';

const ApplyBusinessPrimeContent = () => {
    const { showError } = useContext(DialogContext)

    useEffect(() => {
        if (localStorage?.getItem("error")) {
            showError(localStorage?.getItem("error"))
            localStorage.setItem("error", "")
        }
    }, [])
    
    return (
        <div className="">
            <div className="form-content-container xl px-2 px-sm-3">
                <div className='form-content-header'>
                    <img
                        src={Logo}
                        alt={("fv-bank")}
                        className="logo logo-dark form-content-logo"
                    />
                </div>
                <BusinessContent />
               
            </div>
        </div>
    );
};

export default ApplyBusinessPrimeContent;